import RoutesUtils from "../utils/routes-utils/RoutesUtils";

export default function() {
    const items = [
        {
            title: "DOCUMENTAÇÃO",
            htmlBefore: '<i class="material-icons">description</i>',
            to: "/getting-started",
            isAdminRoute: false,
            requiredScopes: []
        },
        {
            title: "EITRI-APPS",
            htmlBefore: '<i class="material-icons">horizontal_split</i>',
            to: "/applications/1",
            isAdminRoute: false,
            requiredScopes: []
        },
        {
            title: "USUÁRIOS",
            htmlBefore: '<i class="material-icons">people</i>',
            to: "/user-management/users",
            isAdminRoute: true,
            requiredScopes: ["org_manager_account"]
        },
        {
            title: "CONFIGURAÇÕES",
            htmlBefore: '<i class="material-icons">settings</i>',
            to: "/settings",
            isAdminRoute: false,
            requiredScopes: []
        },
        {
            title: "AUTH",
            htmlBefore: '<i class="material-icons">security</i>',
            to: "/auth",
            isAdminRoute: false,
            requiredScopes: ["view_auth"]
        },
        {
            title: "SAIR",
            htmlBefore: '<i class="material-icons">exit_to_app</i>',
            to: "/logout",
            isAdminRoute: false,
            requiredScopes: []
        }
    ];

    return RoutesUtils.getItemsWithOrder(items);
}
